import { render, staticRenderFns } from "./CfhInfo.vue?vue&type=template&id=99e31e96&scoped=true&"
import script from "./CfhInfo.vue?vue&type=script&lang=js&"
export * from "./CfhInfo.vue?vue&type=script&lang=js&"
import style0 from "./CfhInfo.vue?vue&type=style&index=0&id=99e31e96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e31e96",
  null
  
)

export default component.exports